// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2462":"f6110a6e","2589":"32fc1245","9318":"b7826b45"}[chunkId] + ".css";
};